import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Homepage.css';
import logo from '../assets/logo.png';

const Homepage = () => {
    const navigate = useNavigate();

    return (
        <div className="homepage-container">
            <nav className="homepage-nav">
                <div className="nav-logo">
                    <img src={logo} alt="Top Tier Processing" />
                </div>
                <div className="nav-links">
                    <button className="nav-link-btn" onClick={() => navigate('/why-us')}>Why Top Tier?</button>
                    <button className="nav-link-btn" onClick={() => navigate('/careers')}>Careers</button>
                    <button className="nav-login-btn" onClick={() => navigate('/app')}>
                        Client Login
                    </button>
                </div>
            </nav>

            <main className="homepage-hero">
                <div className="hero-content">
                    <div className="hero-logo-large">
                        <img src={logo} alt="Top Tier Processing Logo" />
                    </div>
                    <h1 className="hero-headline">
                        Elevate Your Business with<br />Top Tier Operations
                    </h1>
                    <p className="hero-subtext">
                        We are a premier third-party operations partner for mortgage professionals.
                        From LOA support to post-closing, we handle the entire operational lifecycle—including
                        disclosures, processing, and closing—so you can focus on originating.
                    </p>
                    <button className="hero-cta-btn" onClick={() => navigate('/app')}>
                        Get Started
                    </button>
                </div>
            </main>

            <footer className="homepage-footer">
                <div className="footer-content">
                    <p>
                        <span className="footer-link" onClick={() => navigate('/why-us')}>Why Top Tier?</span> |
                        <span className="footer-link" onClick={() => navigate('/careers')}>Careers</span> |
                        Contact Us: <a href="mailto:info@toptiermp.com">info@toptiermp.com</a>
                    </p>
                    <p className="footer-nmls">NMLS #2256200 | Currently licensed in FL</p>
                    <p>&copy; {new Date().getFullYear()} Top Tier Mortgage Processing. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Homepage;
